var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDebited(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 329.6 315.2",
    style: {
      enableBackground: "new 0 0 329.6 315.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#842029;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.7,108.1c12.4,0,24.9-0.2,37.3,0.1c6.1,0.2,12.3,0.7,18.1,2.3c26.6,7.3,44.5,33.9,41.4,60.6 c-3.5,29.2-26.1,50.8-54.7,51.8C53,223.3,40.3,223,27.5,223c-1.3,0-2.7,0-4.1,0c-1.6,21.2-1.1,41.3,16.3,56.5 c9.7,8.5,21.1,12.6,33.9,12.6c60.8,0,121.5,0.1,182.3,0c29.3-0.1,50.5-21.7,50.7-51.1c0.1-19,0-37.9,0-56.9c0-1,0-2,0-3 c0.1-7.6,5-12.9,11.7-12.8c6.6,0.1,11.2,5.3,11.3,12.8c0,20.3,0.1,40.7,0,61c-0.2,40.5-31.4,72.5-71.9,72.8 c-61.9,0.4-123.8,0.4-185.6,0c-40.7-0.3-71.9-32.4-71.9-73.1C0,191,0,140.2,0.1,89.4c0.1-41.3,32.1-73.2,73.4-73.3 c22.7-0.1,45.4,0,68.1,0c7.8,0,12.9,4.6,12.9,11.5c0,6.9-5.1,11.5-12.8,11.6c-22.7,0-45.4-0.1-68.1,0 c-25.3,0.1-45.6,16.6-49.6,41.6C22.5,89.5,23.7,98.6,23.7,108.1z M23.3,199.7c0.6,0.2,0.9,0.4,1.2,0.4c13.5,0,27,0.6,40.4-0.2 c22-1.3,36.6-21,31.8-42.1c-3.6-16-17.2-26.5-34.7-26.7c-11.8-0.1-23.7,0-35.6,0c-1.1,0-2.1,0.2-3.2,0.3 C23.3,154.4,23.3,177.1,23.3,199.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M268.3,39.6c0,2.4,0,3.7,0,5.1c0,28.4,0,56.9,0,85.3c0,1.1,0,2.2,0,3.4c-0.2,7.4-4.9,12.5-11.6,12.5 c-6.7-0.1-11.3-5.2-11.3-12.7c0-29.6,0-59.1,0-88.7c0-1.3,0-2.7,0-5c-1.6,1.5-2.6,2.4-3.5,3.3c-8.6,8.6-17.1,17.1-25.7,25.7 c-3.5,3.5-7.7,4.6-12.3,3c-4.4-1.5-6.9-4.8-7.5-9.4c-0.6-4.1,1.2-7.5,4.1-10.4c16-16,31.9-32,47.9-47.9c1-1,2.1-1.8,3.3-2.4 c4.6-2.4,9.8-1.5,13.7,2.4c16,16.1,32.1,32.1,48.1,48.2c5.2,5.2,5.4,12.3,0.6,17c-4.6,4.5-11.7,4.3-16.7-0.7 c-8.5-8.4-16.9-16.9-25.4-25.4C270.9,42,270,41.2,268.3,39.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebited);
export default __webpack_public_path__ + "static/media/debited.b84a0eafbe45a6d424681b4721d66edd.svg";
export { ForwardRef as ReactComponent };